import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
import { logError } from "../logging";
import { localeKeyToFullLanguageName } from "./localeKeyToFullLanguageName";
/**
 * Given a list of ILocaleKey, returns true if a duplicate language exists in the list.
 * @param locales list of ILocaleKey to check for duplicate language
 * @returns true if there are one or more duplicate languages in the list
 */ export var hasDuplicateLanguages = function(locales) {
    var languagesSeen = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = locales[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var localeKey = _step.value;
            if (localeKey.language) {
                if (localeKey.language in languagesSeen) {
                    return true;
                } else {
                    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                    languagesSeen[localeKey.language] = 1;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
/**
 * Returns true if the language occurs more than once in the list of locales
 * @param language the language to check for duplicates
 * @param locales the array of locales to check in
 * @returns true if the language occurs more than once
 */ export var isLanguageDuplicatedInLocales = function(language, locales) {
    var timesSeen = 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = locales[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var localeKey = _step.value;
            if (localeKey.language === language && timesSeen > 0) {
                return true;
            }
            if (localeKey.language === language) {
                timesSeen += 1;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
};
var markDuplicateLocaleKeyLanguage = function(availableLocales) {
    var languagesSeen = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = availableLocales[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var localeKey = _step.value;
            if (localeKey.language) {
                if (localeKey.language in languagesSeen) {
                    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                    languagesSeen[localeKey.language] += 1;
                } else {
                    // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
                    languagesSeen[localeKey.language] = 1;
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return availableLocales.filter(function(localeKey) {
        return !!localeKey.language;
    }).map(function(localeKey) {
        // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
        if (languagesSeen[localeKey.language] > 1) {
            return _object_spread_props(_object_spread({}, localeKey), {
                duplicate: true
            });
        }
        return localeKey;
    });
};
/**
 * Returns ILocaleOption list for avaiilable locales. Shows full locale for duplicate languages.
 * E.g. "English (US) - EN-US" and "English (UK) - EN-GB".
 * @param availableLocales list of locale keys
 * @returns list of ILocaleOption with string label and value
 */ export var languageOptionsWithDisambiguatedLocale = function(availableLocales) {
    var availableLocalesWithDuplicatesMarked = markDuplicateLocaleKeyLanguage(availableLocales);
    return availableLocalesWithDuplicatesMarked.map(function(localeKey) {
        if (localeKey.language === undefined) {
            logError(new Error("Cannot create language option from undefined language."));
            return {
                label: "Unknown Language",
                value: {
                    language: Language.LANGUAGE_UNKNOWN,
                    country: undefined
                }
            };
        }
        return {
            label: "".concat(localeKeyToFullLanguageName(localeKey, !!localeKey.duplicate)),
            value: localeKey
        };
    });
};
